import React, { Component } from 'react';
import { ApplicationState } from 'store/rootReducer';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import i18n from 'i18n';
import Button from 'react-bootstrap/Button';
import { confirm } from 'components/ui/modal/BlazeConfirmationModal';
import { bulkDelete } from 'store/marFiles/marFilesActions';
import BzmIcon from '../../../components/icons/BzmIcon';
import ElevioTooltip from '../../../components/overlays/helpTooltip/TitleHelpTooltip/ElevioTooltip';

interface LocalProps {
  selectedMarFilesData?: any;
  unSelectAll?: any;
  selectedMarAssetId?: number;
  selectedMarFileName?: string;
}

class MarFilesHeader extends Component<AllProps> {
  onBulkDeleteClicked = () => {
    this.setState({
      isModalOpen: true,
    });

    const modalBody = (
      <p>
        {i18n.t('marFiles:table.bulkDeleteWarn')}{' '}
        <strong className="text-break">{this.props.selectedMarFilesData.length}</strong>{' '}
        {i18n.t('marFiles:table.selected')}
        {this.props.selectedMarFilesData.length === 1
          ? ` ${i18n.t('marFiles:table.marFile')}`
          : ` ${i18n.t('marFiles:table.marFiles')}`}
        ?
      </p>
    );
    confirm({
      confirmation: modalBody,
      yesOptionTitle: `${i18n.t('common:actions.delete')}`,
      title: `${i18n.t('marFiles:table.deleteMARFiles')}`,
    })
      .then(() => {
        this.onBulkDeleteConfirmed();
      })
      .catch(() => {
        // User chose "No"
      });
  };

  onBulkDeleteConfirmed = () => {
    this.props.bulkDelete(this.props.selectedMarFilesData, this.props.unSelectAll);
  };

  render() {
    const { totalMarFiles, selectedMarFilesData } = this.props;
    const isButtonDisabled = selectedMarFilesData.length === 0;

    const headerText = isButtonDisabled
      ? `(${totalMarFiles})`
      : `(${selectedMarFilesData.length} ${i18n.t('marFiles:header.noOfSelectedMarFiles', {
          totalMarFiles: totalMarFiles,
        })})`;

    return (
      <React.Fragment>
        <Row className="align-items-end">
          <Col sm={10}>
            <h2 className="mb-3">
              <span
                className="mr-2"
                id="marFilesTitle"
                title={`${i18n.t('marFiles:header.marFilesAllCaps')} ${headerText}`}
              >
                {i18n.t('marFiles:header.marFilesAllCaps')} {headerText}
              </span>

              <ElevioTooltip id="MarFilesHelpId" elevioId={'MarFiles_heading_help'} />

              <button
                id={`qa-blk-marfile-delete`}
                className="btn btn-link btn-no-hover p-0 mx-2"
                title={i18n.t('marFiles:table.removeSelectedMarFiles')}
                onClick={this.onBulkDeleteClicked}
                disabled={isButtonDisabled}
              >
                <BzmIcon variant={'icon-bzm-delete'} className={'icon-sm'} />
                <span className="sr-only">{i18n.t('marFiles:table.removeMarFiles')}</span>
              </button>
            </h2>
          </Col>
          {/*Need this here to keep alignment correct with the Transactions tab*/}
          <Col sm={2} className="text-sm-right">
            <Button style={{ visibility: 'hidden' }} className="btn btn-primary btn-circular btn-jb">
              <BzmIcon variant={'icon-bzm-add'} />
            </Button>
          </Col>
        </Row>
        <p>{i18n.t('marFiles:header.description')}</p>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    selectedMarFiles: state.marFiles.selectedMarFiles,
    totalMarFiles: state.marFiles.totalMarFiles,
    isPrivateCloudReadOnly: state.blazeUserConfig.isPrivateCloudReadOnly,
  };
};

const mapDispatchToProps = {
  bulkDelete,
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = typeof mapDispatchToProps;

type AllProps = MapStateToProps & MapDispatchToProps & LocalProps;

export default connect(mapStateToProps, mapDispatchToProps)(MarFilesHeader);
